import { Metric } from '../constants';
import { InsightsDetailsQueryParams } from '../../Router/constants';

const getSelectedMetric = (queryParams: URLSearchParams): Metric | undefined => {
  const metric = queryParams.get(InsightsDetailsQueryParams.METRIC);
  if (!metric) {
    return;
  }

  if (!Object.values(Metric).includes(<Metric>metric)) {
    return;
  }

  return metric as Metric;
};

export { getSelectedMetric };
